import dayjs from 'dayjs'

export type RelationsBlockedState = 'ended' | 'no-exhibitor' | null

/**
 * Decides whether the relations page must be replaced by a message:
 * - 'ended': the trade show is past its deletion date.
 * - 'no-exhibitor': the show is live but the login has no exhibitor registration for it
 *   (e.g. signed in with an email other than the registered one).
 */
export function getRelationsBlockedState({
  deletionDate,
  exhibitorId,
  tradeshowId,
  now,
}: {
  deletionDate?: string | Date
  exhibitorId?: string
  tradeshowId?: string
  now: Date
}): RelationsBlockedState {
  if (deletionDate && dayjs(deletionDate).isBefore(dayjs(now))) {
    return 'ended'
  }

  if (!exhibitorId || !tradeshowId) {
    return 'no-exhibitor'
  }

  return null
}
